// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.rpc.handler

import org.multipaz.cbor.DataItem
import org.multipaz.rpc.handler.InvalidRequestException
import org.multipaz.rpc.handler.RpcExceptionMap
import org.multipaz.cbor.Bstr
import org.multipaz.rpc.handler.toDataItem
import org.multipaz.rpc.handler.fromDataItem

fun InvalidRequestException.Companion.register(exceptionMapBuilder: RpcExceptionMap.Builder) {
    exceptionMapBuilder.addException<InvalidRequestException>(
        "InvalidRequest",
        { exception ->
            exception.toDataItem()
        } ,
        { dataItem ->
            InvalidRequestException.fromDataItem(dataItem)
        } ,
        listOf(
            InvalidRequestException::class,
            )
    )
}
